import { getUrlFromState } from "@dx/user-login-library";

const GITLAB_PAGES_URL = "https://nova-dx-offer-content-39d504029f02f2225b9dbcdf673217df17797b8ef.pages.devops.tui";
const GITLAB_PAGES_URL_REGEX = /nova-dx-offer-content/;
const FEATURE_BRANCH_URL_REGEX = /dx\.pages\.devops\.tui/;

/**
 * Checks if the current URL is a feature branch URL.
 */
export function isFeatureBranchUrl() {
  return FEATURE_BRANCH_URL_REGEX.test(window.location.href);
}

/**
 * Checks if the current URL is a GitLab Pages URL.
 */
export function isGitlabPagesUrl() {
  return GITLAB_PAGES_URL_REGEX.test(window.location.href);
}

/**
 * if we are on a feature branch link, returns the gitlab pages URL
 * otherwise returns undefined.
 */
export function getSSOProxyUrl() {
  return isFeatureBranchUrl() ? GITLAB_PAGES_URL : undefined;
}

/**
 * Extracts the path from the Cognito state.
 *
 * @example
 * getPathFromCognitoState("https://nova.test-tui-mm.com/settings/something/else")
 * returns "/settings/something/else"
 *
 * @example
 * getPathFromCognitoState("https://demo.tui/-/offer/nova/123/artifacts/public/index.html#/experience/exp_id_1/raw/settings")
 * returns "/experience/exp_id_1/raw/settings"
 *
 * @param {string} state - The state string containing the encoded URL.
 */
export function getPathFromCognitoState(state: string) {
  const redirectUrl = getUrlFromState(state);
  const urlObject = new URL(redirectUrl);

  if (urlObject.hash.startsWith("#/")) {
    return urlObject.hash.substring(1);
  }

  return urlObject.pathname;
}

/**
 * Returns the base URL from the given URL.
 *
 * @example
 * getBaseUrlFromUrl("https://example.com/index.html#/settings/something/else")
 * returns "https://example.com/index.html"
 */
export function getBaseUrlFromFeatureBranchUrl(url: string) {
  const [urlBase, rest] = url.split("index.html");
  if (!rest) {
    return url;
  }
  return urlBase + "index.html";
}
